import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Header from "./components/Header";
import HomePage from "./components/HomePage";
import Umrlice from "./components/Umrlice";
import PredajCitulju from "./components/PredajCitulju";
import RegisterPage from "./components/RegisterPage";
import PoslednjiPozdravi from "./components/PoslednjiPozdravi";
import Pomeni from "./components/Pomeni";
import Footer from "./components/Footer";
import Login from "./components/Login";
import UserProfile from "./components/UserProfile";
import FormaZaPopunjavanje from "./components/FormaZaPopunjavanje";
import RedirectForm from "./components/RedirectForm";
import { SubmitForm, FormSize, FormType } from "./components/SubmitForm";
import Test from "./components/Test";
import SinglePost from "./components/SinglePost";
import UpdateForm from "./components/UpdateForm";
import axios from "axios";
import Tutorial from "./components/Tutorial";
import AuthPage from "./components/AuthPage";
import { NotificationContainer } from "react-notifications";
import PaymentPage from "./components/PaymentPage";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPassword from "./components/ResetPassword";
import RegisterSuccess from "./components/RegisterSuccess";

const limit = 10;
let relatedPosts = [];
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("accessToken")
  );
  const [cities, setCities] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [multiple, setMultiple] = useState(false);
  const [offset, setOffset] = useState(0); // Starting index of posts
  const [selectedCity, setSelectedCity] = useState("");
  const [dateCreated, setDateCreated] = useState("");

  const [postData, setPostData] = useState({
    posts: [],
    count: 0,
  });

  const setPosts = (v) => {
    setPostData({
      count: postData.count,
      posts: v,
    });
  };
  const setCount = (v) => {
    setPostData({
      count: v,
      posts: postData.posts,
    });
  };

  useEffect(() => {
    fetchCities();
  }, []);
  useEffect(() => {
    fetchLoggedInUserRole();
  }, []);

  // Get the current URL
  let currentURL = window.location.href;

  // Create a URL object from the current URL
  let urlObject = new URL(currentURL);

  // Get the path from the URL object
  let path = urlObject.pathname;

  // Split the path into parts using '/' as the separator
  let pathParts = path.split("/");

  // Remove any empty parts (caused by leading/trailing slashes)
  pathParts = pathParts.filter((part) => part !== "");

  // Get the last part of the path (the endpoint)
  let endpoint = pathParts[pathParts.length - 1];
  useEffect(() => {
    if (
      !endpoint ||
      endpoint === "umrlice" ||
      endpoint === "pomeni" ||
      endpoint === "poslednji-pozdravi"
    ) {
      fetchPosts(searchQuery); // Use searchQuery prop directly
    }
    window.scrollTo(0, 0);
  }, [offset, searchQuery, selectedCity, dateCreated, endpoint]);
  Date.prototype.mmddyyyy = function () {
    var mm = this.getMonth() + 1; // getMonth() is zero-based
    var dd = this.getDate();

    return [
      this.getFullYear(),
      (mm > 9 ? "" : "0") + mm,
      (dd > 9 ? "" : "0") + dd,
    ].join("-");
  };
  const fetchPosts = async (searchQuery = "") => {
    if (!endpoint) {
      endpoint = "/";
    } else if (endpoint === "umrlice") {
      endpoint = "/umrlice";
    } else if (endpoint === "poslednji-pozdravi") {
      endpoint = "/poslednji_pozdravi";
    } else if (endpoint === "pomeni") {
      endpoint = "/pomeni";
    }

    try {
      const formattedDate = dateCreated
        ? new Date(dateCreated).toISOString()
        : "";
      const response = await axios.get(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${endpoint}`,
        {
          params: {
            limit: limit,
            offset: offset,
            city: selectedCity,
            date_created_after: dateCreated
              ? new Date(dateCreated).mmddyyyy()
              : "",
            ordering: "-id",
            search: searchQuery,
          },
        }
      );

      setPostData({
        posts: response.data.results,
        count: response.data.count,
      });
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const fetchCities = async () => {
    try {
      const response = await axios.get(
        `https://radojicictijanaa.pythonanywhere.com/api/cities`
      );

      if (cities.length === 0) {
        setCities(response.data);
      }
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      setIsLoggedIn(true);
    } else if (!accessToken) {
      setIsLoggedIn(false);
    }
  }, []);

  useEffect(() => {
    const authVerify = () => {
      let decodedJwt;
      let decodedRefresh;
      let refreshToken;
      let token;

      if (
        localStorage.getItem("accessToken") !== null &&
        localStorage.getItem("refreshToken") !== null
      ) {
        token = localStorage.getItem("accessToken");
        refreshToken = localStorage.getItem("refreshToken");
        decodedJwt = parseJwt(token);
        decodedRefresh = parseJwt(refreshToken);
      }

      if (token && refreshToken) {
        if (
          decodedJwt.exp * 1000 < Date.now() &&
          decodedRefresh.exp * 1000 < Date.now()
        ) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          // Update the isLoggedIn state if needed
          setIsLoggedIn(false);
          localStorage.setItem("userRole", "");
          window.location.href = "/";
        } else if (
          decodedJwt.exp * 1000 < Date.now() &&
          decodedRefresh.exp * 1000 < Date.now()
        ) {
          const sendRefresh = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: {
              refresh: refreshToken,
            },
          };
          fetch(
            "https://radojicictijanaa.pythonanywhere.com/api/token/refresh/",
            sendRefresh
          ).then((response) => response.json());
        }
      }
    };

    authVerify();
  }, []);
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const fetchLoggedInUserRole = async () => {
    if (isLoggedIn) {
      try {
        const response = await fetch(
          "https://radojicictijanaa.pythonanywhere.com/api/accounts/",
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          localStorage.setItem("userRole", data.type);
          localStorage.setItem("loggedInUserName", data.username);
        } else {
          // Handle unauthorized or error response
          console.log("Error fetching user data:", response.status);
        }
      } catch (error) {
        console.log("Error fetching user data:", error);
      }
    } else {
      return;
    }
  };

  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );

  const parseJwt = () => {
    let token = localStorage.getItem("accessToken");
    try {
      return JSON.parse(window.atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

  return (
    <Router>
      <div className="App" id="App">
        <Header
          searchQuery={searchQuery}
          handleSearchChange={handleSearchChange}
          isLoggedIn={isLoggedIn}
        />

        <Switch>
          <Route exact path="/posts/update/:postId">
            <UpdateForm cities={cities} />
          </Route>
          <Route exact path="/authorization">
            <AuthPage />
          </Route>

          {isLoggedIn && (
            <Route exact path="/umrlica-sm-form">
              {SubmitForm(
                FormType.Umrlica,
                FormSize.Small,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/umrlica-md-form">
              {SubmitForm(
                FormType.Umrlica,
                FormSize.Medium,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/umrlica-lg-form">
              {SubmitForm(
                FormType.Umrlica,
                FormSize.Large,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/umrlica-qr-form">
              {SubmitForm(
                FormType.Umrlica,
                FormSize.Tiny,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/pp-sm-form">
              {SubmitForm(
                FormType.PoslednjiPozdrav,
                FormSize.Small,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/pp-md-form">
              {SubmitForm(
                FormType.PoslednjiPozdrav,
                FormSize.Medium,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/pp-lg-form">
              {SubmitForm(
                FormType.PoslednjiPozdrav,
                FormSize.Large,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}

          {isLoggedIn && (
            <Route exact path="/pp-qr-form">
              {SubmitForm(
                FormType.PoslednjiPozdrav,
                FormSize.Tiny,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/pomen-sm-form">
              {SubmitForm(
                FormType.Pomen,
                FormSize.Small,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/pomen-md-form">
              {SubmitForm(
                FormType.Pomen,
                FormSize.Medium,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/pomen-lg-form">
              {SubmitForm(
                FormType.Pomen,
                FormSize.Large,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          {isLoggedIn && (
            <Route exact path="/pomen-qr-form">
              {SubmitForm(
                FormType.Pomen,
                FormSize.Tiny,
                cities,
                multiple,
                setMultiple
              )}
            </Route>
          )}
          <Route exact path="/posts/:postId" component={SinglePost} />
          <Route exact path="/tutorial" component={Tutorial} />
          <Route exact path="/register-success" component={RegisterSuccess} />
          <Route
            exact
            path="/"
            component={() =>
              cities.length > 0 &&
              postData.posts.length > 0 && (
                <HomePage
                  limit={limit}
                  cities={cities}
                  posts={postData.posts}
                  count={postData.count}
                  setCount={setCount}
                  offset={offset}
                  setOffset={setOffset}
                  dateCreated={dateCreated}
                  setDateCreated={setDateCreated}
                  selectedCity={selectedCity}
                  setSelectedCity={setSelectedCity}
                  searchQuery={searchQuery}
                  isLoggedIn={isLoggedIn}
                />
              )
            }
          />
          <Route
            path="/umrlice"
            component={() => (
              <Umrlice
                isLoggedIn={isLoggedIn}
                cities={cities}
                posts={postData.posts}
                count={postData.count}
                setCount={setCount}
                offset={offset}
                setOffset={setOffset}
                dateCreated={dateCreated}
                setDateCreated={setDateCreated}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                searchQuery={searchQuery}
              />
            )}
          />
          <Route path="/predaj-citulju">
            {" "}
            <PredajCitulju
              setMultiple={setMultiple}
              multiple={multiple}
              isLoggedIn={isLoggedIn}
            />{" "}
          </Route>
          <Route path="/register" component={RegisterPage} />
          <Route
            path="/poslednji-pozdravi"
            component={() => (
              <PoslednjiPozdravi
                isLoggedIn={isLoggedIn}
                cities={cities}
                posts={postData.posts}
                count={postData.count}
                setCount={setCount}
                offset={offset}
                setOffset={setOffset}
                dateCreated={dateCreated}
                setDateCreated={setDateCreated}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                searchQuery={searchQuery}
              />
            )}
          />
          <Route
            exact
            path="/pomeni"
            component={() => (
              <Pomeni
                cities={cities}
                isLoggedIn={isLoggedIn}
                posts={postData.posts}
                count={postData.count}
                setCount={setCount}
                offset={offset}
                setOffset={setOffset}
                dateCreated={dateCreated}
                setDateCreated={setDateCreated}
                selectedCity={selectedCity}
                setSelectedCity={setSelectedCity}
                searchQuery={searchQuery}
              />
            )}
          />
          <Route path="/zaboravljena-lozinka" component={ForgotPasswordPage} />
          <Route path="/resetuj-lozinku" component={ResetPassword} />
          <Route path="/login" component={Login} />
          <Route path="/payment" component={PaymentPage} />
          <Route
            exact
            path="/forma-za-popunjavanje"
            component={FormaZaPopunjavanje}
          />

          {isLoggedIn ? (
            <Route exact path="/redirect-form" component={RedirectForm} />
          ) : (
            <Redirect to="/" />
          )}
          <PrivateRoute path="/user-profile">
            <UserProfile
              isLoggedIn={isLoggedIn}
              setIsLoggedIn={setIsLoggedIn}
            />
          </PrivateRoute>
          <Redirect to="/" />
        </Switch>
      </div>

      <Footer />
    </Router>
  );
}

export default App;
